import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { AuthShell } from "@/pages/Login";
import { useLang } from "@/lib/i18n";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setDone(true); } catch (e2) { setErr(errMsg(e2)); }
  };
  return (
    <AuthShell title={t("forgot_title")} sub={t("forgot_sub")} testid="forgot-page">
      {done ? <p className="rounded-xl bg-green-50 p-4 text-sm text-green-800" data-testid="forgot-success">{t("forgot_done")}</p> : (
        <form onSubmit={submit} className="grid gap-4">
          <Field label={t("email")}><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" data-testid="forgot-email-input" /></Field>
          {err && <p className="text-sm text-red-600">{err}</p>}
          <button className="h-12 rounded-full bg-[#FF6B00] font-bold text-white hover:bg-[#E05A00]" data-testid="forgot-submit-btn">{t("send_link")}</button>
        </form>
      )}
      <Link to="/login" className="mt-6 block text-center text-sm font-bold text-[#142B5C]" data-testid="back-login-link">{t("back_login")}</Link>
    </AuthShell>
  );
}
